import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processSetting = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_SETTING, item)
}

export const updateSetting = (store, item) => {
    return axios.patch(`/api/settings/${item.key}`, item)
        .then(res => {
            processSetting(store, res.data.data)
            return res
        })
}